import React from 'react'
import {
  MyselfFragment,
  MyselfComponent,
  MyselfQuery,
  SessionFragment
} from '#src/generated/graphql'
import Myself from './Myself.gql'
import { withIdentity, WithIdentityProps as WithIdentityPropsType } from './withIdentity'
import withPermission from './withPermission'
import withAuthentication from './withAuthentication'
import protect from './protect'
import { ApolloQueryResult } from 'apollo-client'
import cookies from 'js-cookie'
import { FullPageLoader } from '@deal/components'

export type WithIdentityProps = WithIdentityPropsType

function getSessionId(session: SessionFragment): string {
  if (process.env.TARGET === 'web') {
    const sessionCookie = cookies.get('deal_sn')
    if (sessionCookie) {
      return atob(sessionCookie.split('.')[1])
    }
  }

  return session.id
}

// Context
type IdentityContextType = {
  myself: MyselfFragment | null
  refetch?: () => Promise<ApolloQueryResult<MyselfQuery>>
  sessionId?: string
  userId?: string
}

const IdentityContext = React.createContext<IdentityContextType>({
  myself: null
})

// Consumer
const IdentityConsumer = IdentityContext.Consumer

// Providers
// This provider is a small wrapper around the context provider, in order to handle the loading state
const IdentityProvider: React.SFC = ({ children }) => (
  <MyselfComponent partialRefetch={true}>
    {({ data, refetch }) => {
      if (data && data.session) {
        return (
          <IdentityContext.Provider
            value={{
              myself: data ? data.me : null,
              sessionId: data && getSessionId(data.session),
              userId: data && data.me ? data.me.user.id : undefined,
              refetch
            }}
          >
            {children}
          </IdentityContext.Provider>
        )
      } else {
        return <FullPageLoader />
      }
    }}
  </MyselfComponent>
)

export {
  IdentityContext,
  IdentityContextType,
  IdentityProvider,
  IdentityConsumer,
  withIdentity,
  withPermission,
  withAuthentication,
  protect,
  Myself
}
